// BottomNavDirector — director tab bar (docs/miniapp-m2-tz.md §3.3 / m3 §3.3).
// 5 tabs with a raised center FAB for «Создать». Mirrors the manager BottomNav's
// .botnav markup so it inherits the design system's bar styling.
import { useLocation, useNavigate } from 'react-router-dom'

import { useAiFeatures } from '../../api/features'
import { hapticImpact } from '../../telegram/tg'
import { Icon, t } from '../../design'

type TabId = 'dashboard' | 'team' | 'deals' | 'ai' | 'create' | 'profile'

const TABS: { id: TabId; icon: JSX.Element; labelKey: string; path: string; fab?: boolean }[] = [
  { id: 'dashboard', icon: <Icon.PieChart size={22} />, labelKey: 'nav.dashboard', path: '/dashboard' },
  { id: 'team', icon: <Icon.Users size={22} />, labelKey: 'nav.team', path: '/team' },
  { id: 'create', icon: <Icon.Plus size={24} sw={2.5} />, labelKey: 'nav.create', path: '/create-task', fab: true },
  { id: 'ai', icon: <Icon.Sparkle size={22} />, labelKey: 'nav.ai', path: '/ai' },
  { id: 'deals', icon: <Icon.Briefcase size={22} />, labelKey: 'nav.deals', path: '/deals' },
  { id: 'profile', icon: <Icon.User size={22} />, labelKey: 'nav.profile', path: '/profile' },
]

export function BottomNavDirector() {
  const location = useLocation()
  const navigate = useNavigate()
  const features = useAiFeatures()
  // Director can hide the whole «AI» tab for the team (themselves included).
  const tabs = features.ai_tab ? TABS : TABS.filter((tb) => tb.id !== 'ai')

  return (
    <nav className="botnav" role="tablist" aria-label="Навигация руководителя">
      {tabs.map((tab) => {
        const active = matchTab(location.pathname, tab.id)
        const go = () => { hapticImpact('light'); navigate(tab.path) }
        if (tab.fab) {
          return (
            <button
              key={tab.id}
              className="botnav-item"
              onClick={go}
              role="tab"
              aria-selected={active}
              aria-label={t(tab.labelKey)}
            >
              <span style={{
                width: 44, height: 44, borderRadius: 14, marginTop: -14,
                background: 'var(--brand-500)', color: '#fff',
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 4px 12px rgba(15,61,110,0.35)',
              }}>
                {tab.icon}
              </span>
              <span>{t(tab.labelKey)}</span>
            </button>
          )
        }
        return (
          <button
            key={tab.id}
            className={`botnav-item ${active ? 'is-active' : ''}`}
            onClick={go}
            role="tab"
            aria-selected={active}
          >
            {tab.icon}
            <span>{t(tab.labelKey)}</span>
          </button>
        )
      })}
    </nav>
  )
}

function matchTab(pathname: string, tab: TabId): boolean {
  if (tab === 'dashboard') return pathname === '/' || pathname.startsWith('/dashboard')
  if (tab === 'team') return pathname.startsWith('/team')
  if (tab === 'deals') return pathname.startsWith('/deals')
  if (tab === 'ai') return pathname.startsWith('/ai')
  if (tab === 'create') return pathname.startsWith('/create-task')
  if (tab === 'profile') return pathname.startsWith('/profile')
  return false
}
